import { AfterViewInit, Component, ElementRef, inject, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { bannerResizeAnimation, slideInFromBottom, stickyAnimation } from './sticky-animation';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TransitionalBanner } from '../../interfaces/transitional-banner-data';
import { HttpService } from '../../services/http.service';
import { NzGridModule, NzRowDirective } from 'ng-zorro-antd/grid';

@Component({
    selector: 'app-magnolia-sticky-banner',
    standalone: true,
    templateUrl: './magnolia-sticky-banner.component.html',
    styleUrl: './magnolia-sticky-banner.component.scss',
    animations: [stickyAnimation, slideInFromBottom, bannerResizeAnimation],
    imports: [NzRowDirective, NzGridModule]
})
export class MagnoliaStickyBannerComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('sentinel', { static: true }) sentinel!: ElementRef;
  @Input() isShowSticky: boolean = false;
  isSticky = true; // ✅ sticky già attivo al load
  isNotCollapsed = true; // ✅ 120px iniziali
  closeBanner: boolean = true;
  showBannerPages: boolean = false;
  bannerData!: TransitionalBanner;
  isBanner: boolean = false;
  isMobile = localStorage.getItem('OnMobile') === 'true';
  img: any;
  // TODO
  bannerState: 'large' | 'small' | 'section' | 'small-mobile' | 'large-mobile' = this.isMobile ? 'small-mobile' : 'large';
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private router: Router,
    private httpService: HttpService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter((event): event is NavigationEnd => event instanceof NavigationEnd),
          takeUntilDestroyed()
        )
        .subscribe((event) => {
          this.showBannerPages = this.getPath(event.urlAfterRedirects);
        });
    }
  }

  getPath(path: any): boolean {
    return path === '/home' || path === '/landing-page';
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.getTransitionalBanner();
    }
  }

  private onScroll = () => {
    // DESKTOP
    if (this.isNotCollapsed && window.scrollY > 300 && !this.isMobile) {
      // Banner piccolo
      this.isNotCollapsed = false;
      this.bannerState = 'small';
    } else if (window.scrollY === 0 && !this.isMobile) {
      // Banner grande
      this.isNotCollapsed = true;
      this.bannerState = 'large';
    }
  };

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem('closeBanner')) {
        this.closeBanner = JSON.parse(sessionStorage.getItem('closeBanner') as string);
      }
    }
  }
  getTransitionalBanner() {
    this.httpService.GetRebrandBanner().subscribe((res: TransitionalBanner) => {
      if(res) {
        setTimeout(() => {
          this.bannerData = new TransitionalBanner(res);
          if (this.bannerData?.image) {
            this.img = this.bannerData.image;
          }
          this.isBanner = this.bannerData?.attivo || false;
        }, 3500);
      }
    });
  }
  handleCloseBanner() {
    this.closeBanner = false;
    sessionStorage.setItem('closeBanner', JSON.stringify(this.closeBanner));
  }
}
